import { c as _c } from "react/compiler-runtime";
import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';
import type { JSX } from 'react';
import { cn } from '@/lib/ui/utils';
function createAlertVariants(): ReturnType<typeof cva<{
  variant: {
    default: string;
    destructive: string;
  };
}>> {
  return cva('relative grid w-full grid-cols-[0_1fr] items-start gap-y-0.5 rounded-lg border px-4 py-3 text-sm has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>svg]:gap-x-3 [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current', {
    variants: {
      variant: {
        default: 'bg-background-primary text-foreground-primary',
        destructive: 'bg-background-primary text-destructive *:data-[slot=alert-description]:text-destructive/90 [&>svg]:text-current'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  });
}
const alertVariants: ReturnType<typeof createAlertVariants> = createAlertVariants();
function Alert(t0) {
  const $ = _c(10);
  let className;
  let props;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = variant;
  } else {
    className = $[1];
    props = $[2];
    variant = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== variant) {
    t1 = cn(alertVariants({
      variant
    }), className);
    $[4] = className;
    $[5] = variant;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== t1) {
    t2 = <div data-slot="alert" role="alert" className={t1} {...props} />;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function AlertTitle(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div data-slot="alert-title" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function AlertDescription(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("col-start-2 grid justify-items-start gap-1 text-sm text-foreground-secondary [&_p]:leading-relaxed", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div data-slot="alert-description" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { Alert, AlertTitle, AlertDescription };